<script setup lang="ts">
import { Mode } from '@/api/types/mode.enum';
import MenuOrderEdit from '@/components/order-edit/menu-order-edit.vue';
import { useBookingDataStore } from '@/stores/bookingData';
import { useBookingStepStore } from '@/stores/bookingStep';
import { onMounted } from 'vue';

const bookingData = useBookingDataStore();
const bookingStep = useBookingStepStore();

onMounted(async () => {
  console.log('summary menu');
})

</script>

<template>
  <div class="bpa-front-tabs--panel-body __bpa-is-active eauget-booking-step-type" data-testid="step-summary-menu-panel">
    <div class="bpa-front-default-card"><!---->
      <div class="bpa-front-dc--body"><!---->
        <div class="el-row">
          <div class="el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-24 el-col-lg-24 el-col-xl-24">
            <div class="bpa-front-module-container bpa-front-module--service" data-testid="menu-confirmation">
              <!-- EAUG-77 §9.2: a menu link whose dishes are already chosen lands here directly. -->
              <menu-order-edit v-if="bookingStep.getMode() == Mode.Menu" part="link" :menu-token="bookingStep.bookingId" />
              <h2 v-if="!bookingData.menuChoiceClosed" class="menu-summary">Merci d'avoir confirmé votre choix !</h2>
              <template v-else>
                <h2 class="menu-summary">Le délai pour choisir vos plats est écoulé</h2>
                <p>Notre chef vous surprendra avec sa «&nbsp;Sélection du Chef&nbsp;», une composition inspirée de la carte du moment.</p>
              </template>
              <br />
              <img src="@/assets/menu-confirmation.jpg">
              <food-summary />
              <menu-summary v-if="!bookingData.menuChoiceClosed" />
              <div class="bpa-front-module-heading">Allergies</div>
              <div class="allergy-summary">
                <p>{{ bookingData.clientInfo.allergy }}</p>
              </div>
              <menu-order-edit v-if="bookingStep.getMode() == Mode.Menu" part="drinks" :menu-token="bookingStep.bookingId" />

              <div class="bpa-front-module--service-items-row">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bpa-front-dc--footer">
        <div class="el-row">
          <div class="el-col el-col-24">
            <div class="bpa-front-tabs--foot"></div>
          </div>
        </div>
      </div>
      <div class="bpa-fm--service__advance-options">
        <div class="bpa-sao--body"><!----> <!----></div>
        <div class="bpa-sao--footer"><button type="button"
            class="el-button bpa-front-btn bpa-front-btn--borderless bpa-front-btn__medium el-button--default"><!----><!----><span>Annuler</span></button>
          <button type="button"
            class="el-button bpa-front-btn bpa-front-btn__medium bpa-front-btn--primary el-button--default"><!----><!----><span>Continuer</span></button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
img {
  width: 50%;
  float: right;
}

@media only screen and (max-width: 576px) {
  .menu-summary, p {
    margin: 0px 15px !important;
  }
}</style>
